module.exports = __webpack_public_path__ + "img/city2.38d38c94.jpg";